import Vue from 'vue';

export default [
    {
        pathId: 'rvs',
        component: 'reviews',
        title: 'Review',
        icon: 'fa-file-signature',
        size: 'md',
        loading: true,
        reload: true
    }, {
        pathId: 'rv',
        component: 'view-review',
        title: 'View',
        icon: 'fa-pencil',
        size: 'lg',
        props: ['reviewId'],
        loading: true
    }, {
        pathId: 'rvra',
        component: 'view-application',
        title: 'View',
        icon: 'fa-pencil',
        size: 'lg',
        props: ['reviewId'],
        loading: true
    },  {
        pathId: 'rvrar',
        component: 'reg-application-reject',
        title: 'Reject Application',
        icon: 'fa-times',
        size: 'md',
        props: ['regAppId', 'reviewId'],
        loading: true
    }, {
        pathId: 'rvea',
        component: 'view-enroll-application',
        title: 'View',
        icon: 'fa-pencil',
        size: 'lg',
        props: ['reviewId'],
        loading: true
    }, {
        pathId: 'rvfa',
        component: 'view-conf-application',
        title: 'View',
        icon: 'fa-pencil',
        size: 'lg',
        props: ['confAppId','confId'],
        loading: true
    }, {
        pathId: 'rvca',
        component: 'view-course-application',
        title: 'View',
        icon: 'fa-pencil',
        size: 'lg',
        props: ['courseAppId','courseId'],
        loading: true
    },
    {
        pathId: 'rrvs',
        component: 'recent-reviews',
        title: 'Recent Reviews',
        icon: 'fa-timer',
        size: 'md',
        loading: true,
        reload: true
    }
];

Vue.component('reviews', () => import('@/cards/reviews/Reviews'));
Vue.component('view-review', () => import('@/cards/reviews/View'));
Vue.component('view-application', () => import('@/cards/reviews/Application'));
Vue.component('reg-application-reject', () => import('@/cards/reviews/RegApplicationReject'));
Vue.component('view-enroll-application', () => import('@/cards/reviews/EnrollApplication'));
Vue.component('view-conf-application', () => import('@/cards/reviews/ConfApplication'));
Vue.component('view-course-application', () => import('@/cards/reviews/CourseApplication'));
Vue.component('recent-reviews', () => import('@/cards/reviews/RecentReviews'));
